import React, { createContext, useContext } from 'react';
import { T as defaultTokens, getRiskColor, getMIAColor, getConfidenceColor } from './tokens';

// ============================================================
// THEME TYPES
// ============================================================
export type Tokens = typeof defaultTokens;

export interface ThemeContextValue {
  T: Tokens;
  getRiskColor: typeof getRiskColor;
  getMIAColor: typeof getMIAColor;
  getConfidenceColor: typeof getConfidenceColor;
}

// ============================================================
// CONTEXT
// ============================================================
const ThemeContext = createContext<ThemeContextValue | null>(null);

// ============================================================
// PROVIDER
// ============================================================
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const value: ThemeContextValue = {
    T: defaultTokens,
    getRiskColor,
    getMIAColor,
    getConfidenceColor,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

// ============================================================
// HOOK
// ============================================================
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
}
